import styled from '@emotion/styled'
import { Flex } from 'mailup-web-components'

export const StatBigNumber = styled.span`
  color: var(--mine-shaft);
  font-size: 28px;
  font-weight: 500;
`

export const StatsInfo = styled(Flex)`
  flex-basis: 25%;
  flex-grow: 0;
  flex-shrink: 0;

  border-left: 1px dotted #d5dadf;

  padding-left: 15px;
  padding-right: 15px;
`
